module.exports = __webpack_public_path__ + "img/programming-browser-1.c2d41fe3.svg";